import { SignalDoc } from "@megaron/docs-contracts";

import { SignalDocumentGroup } from "./groupSignals";

export type SignalGroupReadStatus = "unread" | "read" | "partial";

export const signalGroupReadStatus = (group: SignalDocumentGroup): SignalGroupReadStatus => {
  const unreadCount = group.signals.filter((signal) => !signal.isRead).length;
  if (unreadCount === 0) return "read";
  if (unreadCount === group.signals.length) return "unread";
  return "partial";
};

export const matchesSignalReadFilter = (
  group: SignalDocumentGroup,
  isUnread: boolean | undefined,
): boolean => {
  if (isUnread === undefined) return true;
  const status = signalGroupReadStatus(group);
  if (isUnread) return status !== "read";
  return status === "read";
};

export const unreadSignalDocIds = (groups: SignalDocumentGroup[]): SignalDoc["docId"][] =>
  groups
    .flatMap((group) => group.signals)
    .filter((signal) => !signal.isRead)
    .map((signal) => signal.docId);
